import { useQuery, UseQueryResult } from "@tanstack/react-query";
import axios from "axios";
import { useAuthStore } from "../../../../console/store/useAuthStore";
import { enum_api_uri } from "../../utils/enum";

interface GetOtherBranchResponse {
    customer_idx: number;
    customer_name: string;
    pending_amount: number;
}

export const useGetOtherBranchInfo = (
    customerIdx: number,
    startDate?: Date,
    endDate?: Date,
): UseQueryResult<GetOtherBranchResponse, Error> => {
    const accessToken = useAuthStore(state => state.accessToken);

    return useQuery<GetOtherBranchResponse, Error>({
        queryKey: ["getOtherBranchInfo", customerIdx, startDate, endDate], // startDate, endDate도 key에 포함
        queryFn: async () => {
            const response = await axios.get(`${enum_api_uri.get_settlements_info.replace(":customer_idx", customerIdx.toString())}`, {
                headers: {
                    Authorization: `Bearer ${accessToken}`,
                },
                params: {
                    start_date: startDate ? startDate.toISOString().split("T")[0] : undefined,
                    end_date: endDate ? endDate.toISOString().split("T")[0] : undefined,
                },
            });
            return response.data.data;
        },
        placeholderData: prevData => prevData,
    });
};
